const FormularioButom = (props) => {
  const { disabled = false, type = "submit", onClick } = props;

  return (
    <div className="form-actions">
      <button
        type={type}
        className={`btn-primary ${disabled ? "is-disabled" : ""}`}
        id="submit-btn"
        disabled={disabled}
        onClick={onClick}
      >
        {props.icone} <span id="submit-label">{props.children}</span>
      </button>
    </div>
  );
};

export default FormularioButom;
